(function () {
  'use strict';

  var CTA_RE = /\b(shop|start|discover|explore|learn more|get started|contact|support|relief|comfort|solution|buy|order)\b/i;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function textOf(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function directChildren(container) {
    return toArray(container ? container.children : []).filter(function (child) {
      return child.nodeType === 1 && !child.hasAttribute('data-kc-generated');
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"]/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[char];
    });
  }

  function getAvatarList(root) {
    var script = root.parentElement && root.parentElement.querySelector('script[id^="kc-default-page-avatar-data-"]');
    if (!script) {
      script = document.querySelector('script[id^="kc-default-page-avatar-data-"]');
    }
    if (!script) {
      return [];
    }
    try {
      var data = JSON.parse(script.textContent || '{}');
      return Array.isArray(data.avatars) ? data.avatars.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function cleanQuote(value) {
    return (value || '')
      .replace(/^\s*[“”"']\s*/, '')
      .replace(/\s*[“”"']\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cleanAuthor(value) {
    var author = cleanQuote(value || 'Verified Customer');
    author = author.replace(/^verified\s*[·-]\s*/i, '').trim();
    author = author.replace(/^verified\s+customer$/i, 'Verified Customer');
    return author || 'Verified Customer';
  }

  function splitQuoteAndAuthor(text) {
    var normalized = (text || '').replace(/\s+/g, ' ').trim();
    var author = '';
    var quote = normalized;
    var dashMatch = normalized.match(/^(.*?)[\s\u00a0]+(?:—|–|-)\s*(.+)$/);
    if (dashMatch && dashMatch[1].length > 20 && dashMatch[2].length < 90) {
      quote = dashMatch[1];
      author = dashMatch[2];
    }
    quote = cleanQuote(quote);
    author = cleanAuthor(author || 'Verified Customer');
    return { quote: quote, author: author };
  }

  function isTestimonialNode(node) {
    if (!node || node.dataset.kcTestimonialEnhanced === 'true') {
      return false;
    }
    var text = textOf(node);
    if (text.length < 45) {
      return false;
    }
    var hasQuote = /[“”"]/.test(text);
    var hasAuthorDash = /(?:—|–|-)\s*[A-Z][A-Za-z .,'’]+(?:,\s*\d{2})?\s*$/.test(text);
    var hasCustomerSignal = /\b(Verified Customer|Customer|Pro Cream|Pro Roll|Cooling Cream)\b/i.test(text);
    return hasQuote || hasAuthorDash || hasCustomerSignal;
  }

  function makeCard(sourceNode, index, avatars) {
    var parts = splitQuoteAndAuthor(sourceNode.textContent || '');
    if (!parts.quote) {
      return null;
    }

    var card = document.createElement('article');
    card.className = 'kc-dp-testimonial-card';
    card.setAttribute('aria-label', 'Customer testimonial');
    card.dataset.kcTestimonialEnhanced = 'true';

    var avatarWrap = document.createElement('div');
    avatarWrap.className = 'kc-dp-testimonial__avatar';
    avatarWrap.setAttribute('aria-hidden', 'true');

    if (avatars.length) {
      var img = document.createElement('img');
      img.src = avatars[index % avatars.length];
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      avatarWrap.appendChild(img);
    }

    var content = document.createElement('div');
    content.className = 'kc-dp-testimonial__content';

    var quote = document.createElement('p');
    quote.className = 'kc-dp-testimonial__quote';
    quote.textContent = parts.quote;

    var author = document.createElement('p');
    author.className = 'kc-dp-testimonial__author';
    if (/^verified customer$/i.test(parts.author)) {
      author.innerHTML = '<span class="kc-dp-testimonial__badge">Verified Customer</span>';
    } else {
      author.innerHTML = '<span class="kc-dp-testimonial__badge">Verified Customer</span> · ' + escapeHtml(parts.author);
    }

    content.appendChild(quote);
    content.appendChild(author);
    card.appendChild(avatarWrap);
    card.appendChild(content);
    return card;
  }

  function enhanceSocialProof(root) {
    if (!root) {
      return;
    }
    var avatars = getAvatarList(root);
    var sections = root.querySelectorAll('.kc-default-page__rte .section-social_proof');
    sections.forEach(function (section) {
      if (section.dataset.kcAvatarEnhanced === 'true') {
        return;
      }
      var quoteNodes = directChildren(section).filter(function (node) {
        return (node.tagName === 'P' || node.tagName === 'BLOCKQUOTE') && isTestimonialNode(node);
      });
      if (!quoteNodes.length) {
        return;
      }
      section.classList.add('kc-dp-social-proof--enhanced');
      quoteNodes.forEach(function (node, index) {
        var card = makeCard(node, index, avatars);
        if (card) {
          node.replaceWith(card);
        }
      });
      section.dataset.kcAvatarEnhanced = 'true';
    });
  }

  function splitInlineFaq(text) {
    var pairs = [];
    var regex = /Q:\s*([\s\S]*?)\s*A:\s*([\s\S]*?)(?=\s*Q:\s*|$)/gi;
    var match;
    while ((match = regex.exec(text || '')) !== null) {
      if (match[1] && match[2]) {
        pairs.push({ q: match[1].trim(), a: match[2].trim() });
      }
    }
    return pairs;
  }

  function createFaqItem(question, answer) {
    var item = document.createElement('div');
    item.className = 'kc-dp-faq__item';
    item.setAttribute('data-kc-generated', 'true');

    var q = document.createElement('p');
    q.className = 'kc-dp-faq__question';
    q.textContent = String(question || '').replace(/^Q:\s*/i, '').trim();

    var a = document.createElement('p');
    a.className = 'kc-dp-faq__answer';
    a.textContent = String(answer || '').replace(/^A:\s*/i, '').trim();

    item.appendChild(q);
    item.appendChild(a);
    return item;
  }

  function enhanceFaq(root) {
    var scopes = toArray(root.querySelectorAll('.kc-default-page__rte .section-faq, .kc-default-page__rte .section-questions, .kc-default-page__rte [class*="faq"], .kc-default-page__rte [class*="question"]'));
    scopes.forEach(function (scope) {
      if (scope.dataset.kcFaqEnhanced === 'true' || scope.querySelector('.kc-dp-faq')) {
        return;
      }

      var children = directChildren(scope);
      var pairs = [];

      for (var i = 0; i < children.length; i += 1) {
        var node = children[i];
        if (!node || node.tagName !== 'P') {
          continue;
        }

        var inlinePairs = splitInlineFaq(textOf(node));
        if (inlinePairs.length) {
          inlinePairs.forEach(function (pair) {
            pairs.push({ q: pair.q, a: pair.a, remove: [node] });
          });
          continue;
        }

        var next = children[i + 1];
        if (next && next.tagName === 'P') {
          var currentText = textOf(node);
          var nextText = textOf(next);
          var looksLikeQuestion = /\?$/.test(currentText) || /^Q:\s*/i.test(currentText);
          var looksLikeAnswer = nextText.length > 20 && !/\?$/.test(nextText);
          if (looksLikeQuestion && looksLikeAnswer) {
            pairs.push({ q: currentText, a: nextText, remove: [node, next] });
            i += 1;
          }
        }
      }

      if (!pairs.length) {
        return;
      }

      var faq = document.createElement('div');
      faq.className = 'kc-dp-faq';
      faq.setAttribute('data-kc-generated', 'true');

      var insertAfter = scope.querySelector('h2, h3') || null;
      if (insertAfter && insertAfter.nextSibling) {
        scope.insertBefore(faq, insertAfter.nextSibling);
      } else {
        scope.appendChild(faq);
      }

      pairs.forEach(function (pair) {
        faq.appendChild(createFaqItem(pair.q, pair.a));
        pair.remove.forEach(function (node) {
          if (node && node.parentNode) {
            node.remove();
          }
        });
      });

      scope.classList.add('kc-dp-faq--enhanced');
      scope.dataset.kcFaqEnhanced = 'true';
    });
  }

  function enhanceCta(root) {
    var sections = toArray(root.querySelectorAll('.kc-default-page__rte .section-cta, .kc-default-page__rte .section_cta, .kc-default-page__rte [class*="cta"]'));
    sections.forEach(function (section, index) {
      if (section.dataset.kcCtaEnhanced === 'true') {
        return;
      }

      var link = section.querySelector('a[href]');
      var heading = section.querySelector('h2, h3');
      var sectionText = textOf(section);
      var isLinkOnly = link && !heading && sectionText === textOf(link);
      var previous = section.previousElementSibling;

      if (isLinkOnly && previous && previous.classList && /section[-_]cta|kc-dp-cta-panel/.test(previous.className)) {
        previous.classList.add('kc-dp-cta-panel');
        previous.appendChild(section);
      } else if (CTA_RE.test(sectionText) || link || heading) {
        section.classList.add('kc-dp-cta-panel');
      }

      var activePanel = section.closest('.kc-dp-cta-panel') || section;
      var activeLink = activePanel.querySelector('a[href]');
      if (activeLink) {
        activeLink.classList.add('kc-dp-button-link');
        if (!textOf(activeLink)) {
          activeLink.textContent = 'Shop Topical Comfort Now';
        }
        activeLink.setAttribute('aria-label', textOf(activeLink));
      }

      section.dataset.kcCtaEnhanced = 'true';
      activePanel.dataset.kcCtaEnhanced = 'true';
    });
  }

  function run() {
    document.querySelectorAll('.kc-default-page').forEach(function (root) {
      enhanceSocialProof(root);
      enhanceFaq(root);
      enhanceCta(root);
    });
  }

  ready(run);
  document.addEventListener('shopify:section:load', run);
})();
